import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import React from "react";
import ReactDOMClient from "react-dom/client";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { AuthProvider } from "./hooks/useAuth";

import { Provider } from "react-redux";
import { store } from "./store";

if (process.env.REACT_APP_ENV === "production") {
  Sentry.init({
    dsn: "https://6105458b53f8d9e9db3244581d02ae1b@o4507281255628800.ingest.us.sentry.io/4509734055510016",
    sendDefaultPii: true,
  });
} else {
  console.log("Sentry disabled in development");
}

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container);

if (
  process.env.REACT_APP_ENV === "staging" ||
  process.env.REACT_APP_ENV === "production"
) {
 root.render(
    <React.StrictMode>
      <Provider store={store}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </Provider>
    </React.StrictMode>
  );
} else {
  root.render(
    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Provider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
